<template>
	<div>
		<CLoader :pConfigLoad="ConfigLoad">
			<template slot="BodyFormLoad">
				<div class="row">
					<div class="col-lg-9">
						<div class="row">
							<div class="col-lg-4">
                    		    <label >Código Empresa </label>
                    		    <input type="text" v-model="ProyectoEquipo.CodigoEmpresa" class="form-control" placeholder="Código Empresa" />
                    		    <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.CodigoEmpresa" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                    		</div>
							<div class="col-lg-4">
                    		    <label >Código Fabricante </label>
                    		    <input type="text" v-model="ProyectoEquipo.CodigoFabricante" class="form-control" placeholder="SKU" />
                    		    <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.CodigoFabricante" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                    		</div>
							<div class="col-lg-4">
                    		    <label >Ítem </label>
                    		    <input type="text" v-model="ProyectoEquipo.Item" class="form-control" placeholder="Item" />
                    		    <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Item" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                    		</div>
						</div>
						<div class="row">
							<div class="col-lg-3">
                    		    <label >Unidad </label>
                    		    <input type="text" v-model="ProyectoEquipo.Unidad" class="form-control" placeholder="Unidad" />
                    		    <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Unidad" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                    		</div>
							<div class="col-lg-3">
								<label>Marca</label>
								<input type="text" class="form-control" v-model="ProyectoEquipo.Marca" placeholder="Marca">
								<label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Marca" :Mensaje="this.errorvalidacion.Marca[0]"></Cvalidation></label>
							</div>
							<div class="col-lg-3">
								<label>Modelo</label>
								<input type="text" class="form-control" v-model="ProyectoEquipo.Modelo" placeholder="Modelo">
								<label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Modelo" :Mensaje="this.errorvalidacion.Modelo[0]"></Cvalidation></label>
							</div>
							<div class="col-lg-3">
								<label>Factura</label>
								<input type="text" class="form-control" v-model="ProyectoEquipo.Factura" placeholder="Factura">
								<label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Factura" :Mensaje="this.errorvalidacion.Factura[0]"></Cvalidation></label>
							</div>
						</div>
						<div class="row">
							<div class="col-lg-2">
                    		    <label >Presupuesto</label>
                    		    <vue-numeric placeholder="$ 0.00"  :minus="false"  class="form-control "  currency="$" separator="," :precision="2" v-model="ProyectoEquipo.Presupuesto"></vue-numeric>
                    		    <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Presupuesto" :Mensaje="this.errorvalidacion.Presupuesto[1]"></Cvalidation></label>
                    		</div>
							<div class="col-lg-2">
                    		    <label >Comprometido</label>
                    		    <vue-numeric placeholder="$ 0.00"  :minus="false"  class="form-control "  currency="$" separator="," :precision="2" v-model="ProyectoEquipo.Comprometido"></vue-numeric>
                    		    <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Comprometido" :Mensaje="this.errorvalidacion.Comprometido[1]"></Cvalidation></label>
                    		</div>
							<div class="col-lg-2">
                    		    <label >Adquirido</label>
                    		    <vue-numeric placeholder="$ 0.00"  :minus="false"  class="form-control "  currency="$" separator="," :precision="2" v-model="ProyectoEquipo.Adquirido"></vue-numeric>
                    		    <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Adquirido" :Mensaje="this.errorvalidacion.Adquirido[1]"></Cvalidation></label>
                    		</div>
							<div class="col-lg-2">
								<label for="">Requerido</label>
								<v-date-picker v-model="ProyectoEquipo.Requerido" :mode="typeCalendar"
									:popover="{
										placement: 'bottom',
										visibility: 'click'
									}"
									:input-props="{
										class: 'form-control cal-black',
										style: 'cursor:pointer;'
									}"
                				    :locale="'es-MX'"
								/>
							</div>
							<div class="col-lg-2">
								<label for="">Compra</label>
								<v-date-picker v-model="ProyectoEquipo.Compra" :mode="typeCalendar"
									:popover="{
										placement: 'bottom',
										visibility: 'click'
									}"
									:input-props="{
										class: 'form-control cal-black',
										style: 'cursor:pointer;'
									}"
                				    :locale="'es-MX'"
								/>
							</div>
							<div class="col-lg-2">
								<label for="">Cantidad</label>
								<input type="text" class="form-control" v-model="ProyectoEquipo.Cantidad">
							</div>
						</div>
						<div class="row">
							<div class="col-lg-3">
								<label for="">Estatus</label>
								<select v-model="ProyectoEquipo.Estatus" class="form-control">
									<option value="">-Estatus-</option>
									<option value="1">Comprado</option>
									<option value="2">Proceso Compra</option>
									<option value="3">Pendiente</option>
									<option value="4">No Disponible</option>
									<option value="5">Cancelado</option>
								</select>
							</div>
						</div>
					</div>
					<div class="col-lg-3">
						<div class="row">
							<div class="col-lg-12">
								<div class="avatar-upload almacen-upload">
									<div class="avatar-edit">
										<input
											id="fileequipo"
											ref="imagenequipo"
											type="file"
											name="myfile"
											@change="uploadImage()"
											accept=".png, .jpg, .jpeg"
										/>
										<label for="fileequipo"></label>
									</div>
									<div class="avatar-preview imagenes-almacen">
										<div
											id="imagePreviewEquipo"
											style="background-image: url(Img);"
										></div>
									</div>
								</div>
								<label class="ml-5 pl-3 mt-2">Recomendada 400 x 400</label>
							</div>
						</div>
					</div>
				</div>
				<div class="row mt-3">
					<div class="col-lg-12">
						<label for="">Descripción</label>
						<textarea v-model="ProyectoEquipo.Descripcion" maxlength="70" cols="30" rows="1" class="form-control" placeholder="Descripción"></textarea>
					</div>
				</div>
			</template>
		</CLoader>
	</div>
</template>

<script>
import Cbtnsave from '@/components/Cbtnsave.vue'
import Clist from '@/components/Clist.vue';
import Cvalidation from '@/components/Cvalidation.vue'
import ListForm from '@/components/Clistform.vue';
import Cbtnaccion from "@/components/Cbtnaccion.vue";
import Modal from '@/components/Cmodal.vue';
import $$ from "jquery";

export default {
	name:'Form',
	props:['NameList','poBtnSave'],
	components:{Cbtnsave,Clist,Cvalidation,Modal,ListForm,Cbtnaccion},
	data() {
		return {
			Modal:true,
			FormName:'MaterialForm',//Sirve para donde va regresar
            ConfigLoad:{
                ShowLoader:true,
                ClassLoad:true
            },
			ProyectoEquipo:{
				IdProyectoEquipo:0,
				IdProyecto:0,
				IdEquipoCot:0,
				CodigoEmpresa:'',
				CodigoFabricante:'',
				Item:'',
				Unidad:'',
				Marca:'',
				Modelo:'',
				Cantidad:'',
				Factura:'',
				Presupuesto:'',
				Comprometido:'',
				Adquirido:'',
				Requerido:'',
				Compra:'',
				Estatus:'',
				Descripcion:'',
				Imagen:''
			},
			Imagen:"",
			errorvalidacion:[],
			EmitSeccion:this.poBtnSave.EmitSeccion
		}
	},
	methods: {
		async Guardar(){
			let FechaRequerido='';
			let FechaCompra='';
			if (this.ProyectoEquipo.Requerido!='' && this.ProyectoEquipo.Requerido!=undefined) {
                let day=this.ProyectoEquipo.Requerido.getDate();
                let month=this.ProyectoEquipo.Requerido.getMonth()+1;
                let year=this.ProyectoEquipo.Requerido.getFullYear();
                FechaRequerido=year+'-'+month+'-'+day;   
            }
			if (this.ProyectoEquipo.Compra!='' && this.ProyectoEquipo.Compra!=undefined) {
                let day=this.ProyectoEquipo.Compra.getDate();
                let month=this.ProyectoEquipo.Compra.getMonth()+1;
                let year=this.ProyectoEquipo.Compra.getFullYear();
                FechaCompra=year+'-'+month+'-'+day;   
            }
			this.poBtnSave.toast=0; 
            this.poBtnSave.disableBtn=true;
			let formData=new FormData();
			formData.set('IdProyectoEquipo',this.ProyectoEquipo.IdProyectoEquipo);
			formData.set('IdProyecto',this.ProyectoEquipo.IdProyecto);
			formData.set('IdEquipoCot',this.ProyectoEquipo.IdEquipoCot);
			formData.set('CodigoEmpresa',this.ProyectoEquipo.CodigoEmpresa);
			formData.set('CodigoFabricante',this.ProyectoEquipo.CodigoFabricante);
			formData.set('Item',this.ProyectoEquipo.Item);
			formData.set('Unidad',this.ProyectoEquipo.Unidad);
			formData.set('Marca',this.ProyectoEquipo.Marca);
			formData.set('Modelo',this.ProyectoEquipo.Modelo);
			formData.set('Factura',this.ProyectoEquipo.Factura);
			formData.set('Cantidad',this.ProyectoEquipo.Cantidad);
			formData.set('Presupuesto',this.ProyectoEquipo.Presupuesto);
			formData.set('Comprometido',this.ProyectoEquipo.Comprometido);
			formData.set('Adquirido',this.ProyectoEquipo.Adquirido);
			formData.set('Requerido',FechaRequerido);
			formData.set('Compra',FechaCompra);
			formData.set('Estatus',this.ProyectoEquipo.Estatus);
			formData.set('Descripcion',this.ProyectoEquipo.Descripcion);
			formData.set('Imagen',this.ProyectoEquipo.Imagen);
			let file = this.$refs.imagenequipo.files[0];
			formData.append("ImagenFile", file);
			await this.$http.post('proyectoequipo/modify',formData,{
				headers: {
                    'Content-Type': 'multipart/form-data'
                }
			}).then((res)=>{
				this.poBtnSave.disableBtn=false;  
                this.poBtnSave.toast=1;
                $('#'+this.EmitSeccion).modal('hide');
				this.bus.$emit('ListaPrincipal');
			}).catch((err)=>{
				this.errorvalidacion=err.response.data.message.errores;
                this.poBtnSave.disableBtn=false;
                this.poBtnSave.toast=2;
			});
		},
		Limpiar(){
			this.ProyectoEquipo={
				IdProyectoEquipo:0,
				IdProyecto:0,
				IdEquipoCot:0,
				CodigoEmpresa:'',
				CodigoFabricante:'',
				Item:'',
				Unidad:'',
				Marca:'',
				Modelo:'',
				Factura:'',
				Cantidad:'',
				Presupuesto:'',
				Comprometido:'',
				Adquirido:'',
				Requerido:new Date(),
				Compra:new Date(),
				Estatus:'',
				Descripcion:'',
				Imagen:''
			};
			this.errorvalidacion=[];
			this.Imagen="";
			const input = this.$refs.imagenequipo;
			input.type = 'text'
            input.type = 'file';
			this.readURL(this.Imagen);
		},
		get_one(){
			this.ConfigLoad.ShowLoader=true;
			this.$http.get('proyectoequipo/recovery',{
				params:{IdProyectoEquipo: this.ProyectoEquipo.IdProyectoEquipo}
			}).then((res)=>{
				this.ProyectoEquipo=res.data.data.proyectoequipo;
				let Foto=res.data.data.proyectoequipo.Imagen;
				if (Foto != "" && Foto != null) {
					this.Imagen = res.data.data.ruta + this.ProyectoEquipo.Imagen;
				}
				this.readURL(this.Imagen);
				if (res.data.data.proyectoequipo.Requerido!=null){
					let formatedDate = res.data.data.proyectoequipo.Requerido.replace(/-/g, "\/");
					this.ProyectoEquipo.Requerido=new Date(formatedDate);
				}
				if (res.data.data.proyectoequipo.Compra!=null){
					let formatedDate2 = res.data.data.proyectoequipo.Compra.replace(/-/g, "\/");
					this.ProyectoEquipo.Compra=new Date(formatedDate2);
				}
			}).finally(()=>{
				this.ConfigLoad.ShowLoader=false;
			})
		},
		uploadImage() {
			this.ProyectoEquipo.Imagen = this.$refs.imagenequipo.files[0];
			const image = this.$refs.imagenequipo.files[0];
			const reader = new FileReader();
			var img = "";
			reader.readAsDataURL(image);

			reader.onload = e => {
				this.Imagen = e.target.result;
				this.readURL(this.Imagen);
			};
		},
		readURL(input) {
			$$("#imagePreviewEquipo").css("background-image", "url(" + this.Imagen + ")");
			$$("#imagePreviewEquipo").hide();
			$$("#imagePreviewEquipo").fadeIn(650);
		},
	},
	created() {
		this.bus.$off("NewModal_"+this.EmitSeccion);
		this.bus.$on("NewModal_"+this.EmitSeccion,(data,Id,IdProyecto)=>{
            this.poBtnSave.disableBtn=false;
			// console.log(this.pListProyectoReporteObra);
            this.bus.$off("Save_"+this.EmitSeccion);
            this.bus.$on("Save_"+this.EmitSeccion, () => {
				this.Guardar();
			});
            this.Limpiar();
            if (IdProyecto!==undefined) {
                this.ProyectoEquipo.IdProyecto=IdProyecto;
            }
            if (Id > 0) {
				this.ProyectoEquipo.IdProyectoEquipo = Id;
				this.get_one();
			}
        });
	},
	computed:{
        typeCalendar:function(){
            return 'single';
        },
    }
}
</script>

<style>

</style>
